export enum PlanPeriodsEnum {
  Monthly = 'Monthly',
  Annual = 'Annual',
}
